(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_rs-campaign"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-campaign-panel')) {
    customElements.define(
      'rs-campaign-panel',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Number(this.dataset.end) || 0;
          this.designMode = this.dataset.designMode === 'true';
          this.countdown = this.querySelector('[data-countdown]');
          // Bound once so a reconnect (theme editor re-render) doesn't add duplicate handlers
          this.boundClick ??= this.onClick.bind(this);
          this.boundTick ??= this.tick.bind(this);
          this.addEventListener('click', this.boundClick);
          if (!this.end) return;
          this.boundTick();
          clearInterval(this.timer);
          this.timer = setInterval(this.boundTick, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.removeEventListener('click', this.boundClick);
        }

        tick() {
          const left = this.end - Date.now() / 1000;

          // Remove the campaign at its end time even when the page came from cache;
          // the remaining panels then share the row
          if (left <= 0 && !this.designMode) {
            clearInterval(this.timer);
            const grid = this.parentElement;
            this.remove();
            if (grid && !grid.children.length) {
              (grid.closest('.shopify-section') || grid).hidden = true;
            }
            return;
          }

          if (this.countdown) this.countdown.textContent = this.format(Math.max(0, left));
        }

        format(seconds) {
          const d = Math.floor(seconds / 86400);
          const h = Math.floor((seconds % 86400) / 3600);
          const m = Math.floor((seconds % 3600) / 60);
          const s = Math.floor(seconds % 60);
          const pad = (n) => String(n).padStart(2, '0');
          return d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
        }

        async onClick(event) {
          const button = event.target.closest('[data-copy]');
          if (!button) return;

          const code = button.dataset.copy;
          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }

          const text = button.querySelector('[data-copy-text]');
          const status = button.parentElement.querySelector('[data-copy-status]');
          const original = text.textContent;
          text.textContent = button.dataset.copiedLabel;
          if (status) status.textContent = `${code} ${button.dataset.copiedLabel}`;
          clearTimeout(button._resetTimer);
          button._resetTimer = setTimeout(() => {
            text.textContent = original;
            if (status) status.textContent = '';
          }, 2000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rs-instagram"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-ig-slider')) {
    customElements.define(
      'rs-ig-slider',
      class extends HTMLElement {
        connectedCallback() {
          // Moving the element (e.g. theme editor re-render) reconnects it: set up only once
          if (this.ready) {
            this.observer?.observe(this);
            if (this.onBlockSelect) document.addEventListener('shopify:block:select', this.onBlockSelect);
            return;
          }
          this.ready = true;

          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.slides = [...this.track.querySelectorAll('.rs-ig__slide')];
          this.index = 0;
          this.slides.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`));
          if (this.slides.length < 2) return;

          this.buildControls();

          let scrollTimer;
          this.onScroll = () => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => this.syncIndex(), 80);
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          // Theme editor: jump to a post when its block is selected
          this.onBlockSelect = (event) => {
            const i = this.slides.findIndex((slide) => slide.contains(event.target));
            if (i < 0) return;
            this.paused = true;
            this.stopAutoplay();
            this.goTo(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.delay = Number(this.dataset.autoplay) || 0;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.delay = 0;
          if (!this.delay) {
            this.querySelector('[data-pause]')?.remove();
            return;
          }

          // Pause while hovered/focused or off screen
          this.addEventListener('mouseenter', () => { this.hovered = true; this.stopAutoplay(); });
          this.addEventListener('mouseleave', () => { this.hovered = false; this.startAutoplay(); });
          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.visible ? this.startAutoplay() : this.stopAutoplay();
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.stopAutoplay();
          this.observer?.disconnect();
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        buildControls() {
          const controls = this.querySelector('[data-controls]');
          const dots = this.querySelector('[data-dots]');
          this.dots = this.slides.map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'rs-ig__dot';
            dot.setAttribute('aria-label', `Go to post ${i + 1} of ${this.slides.length}`);
            dot.addEventListener('click', () => this.goTo(i));
            dots.append(dot);
            return dot;
          });
          this.updateDots();

          this.querySelector('[data-prev]').addEventListener('click', () => this.goTo(this.index - 1));
          this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.index + 1));
          this.querySelector('[data-pause]')?.addEventListener('click', (event) => {
            this.paused = !this.paused;
            this.toggleAttribute('data-paused', this.paused);
            event.currentTarget.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
            this.paused ? this.stopAutoplay() : this.startAutoplay();
          });
          controls.hidden = false;
        }

        // Scroll offset of a slide, measured from the real layout (slide widths can be fractional)
        slideOffset(index) {
          return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
        }

        syncIndex() {
          const left = this.track.scrollLeft;
          let index = 0;
          this.slides.forEach((_, i) => {
            if (Math.abs(this.slideOffset(i) - left) < Math.abs(this.slideOffset(index) - left)) index = i;
          });
          if (index === this.index) return;
          this.index = index;
          this.updateDots();
        }

        goTo(index) {
          const count = this.slides.length;
          this.index = (index + count) % count;
          this.track.scrollTo({ left: this.slideOffset(this.index) });
          this.updateDots();
        }

        updateDots() {
          this.dots?.forEach((dot, i) => {
            if (i === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        startAutoplay() {
          if (!this.delay || this.paused || this.hovered || this.visible === false) return;
          this.stopAutoplay();
          this.autoplay = setInterval(() => this.goTo(this.index + 1), this.delay);
        }

        stopAutoplay() {
          clearInterval(this.autoplay);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
